import ResourceTyped from 'Resources/ResourceTyped';

export type AIScoringType = {
	id: number;
	type: string;
	score: number;
	clientId: number;
	regBy: number;
	regDate: string;
	extra: string; // stringified JSON
};

class AIScoring extends ResourceTyped<AIScoringType> {
	constructor() {
		super('master/aiScoring');
	}
}

const resource = new AIScoring();

export default resource;
